import React from 'react';

import { Select, SelectOption } from '@flixbus/honeycomb-react';
import { Asterisk } from '../../Asterisk';
import { useVoucherFormContext } from '../../Context';
import { AllowedPlatform, AllowedPlatformsRule } from '../../../../types/Rules';

const VoucherFormAllowedPlatforms: React.FC<{ disabled: boolean }> = ({ disabled }) => {
  const {
    formState: {
      payload: { rules },
    },
    handleRuleChange,
  } = useVoucherFormContext();
  const offlineSalesSelected = rules.some(r => r.type === 'offline_sales');
  const allowedPlatformsState = rules.filter(r => r.type === 'allowed_platforms')[0] as
    | AllowedPlatformsRule
    | undefined;

  const handleValueChange = (value: AllowedPlatform) => {
    if (value === 'offline_sales') {
      handleRuleChange({ type: 'offline_sales' });
      handleRuleChange(
        {
          type: 'allowed_platforms',
          platforms: [value],
        },
        true,
      );
    } else {
      handleRuleChange({ type: 'offline_sales' }, true);
      handleRuleChange(
        {
          type: 'allowed_platforms',
          platforms: [value],
        },
        value === 'all',
      );
    }
  };

  return (
    <Select
      id='allowed-platforms'
      value={offlineSalesSelected ? 'offline_sales' : allowedPlatformsState?.platforms[0] || 'all'}
      disabled={disabled}
      onChange={e => handleValueChange(e.target.value as AllowedPlatform)}
      label={
        <>
          Allowed platforms <Asterisk />
        </>
      }
    >
      <SelectOption value='all'>Web and App booking</SelectOption>
      <SelectOption value='web'>Web booking</SelectOption>
      <SelectOption value='mobile_pax'>Mobile App booking</SelectOption>
      <SelectOption value='offline_sales'>Offline booking</SelectOption>
    </Select>
  );
};

export default VoucherFormAllowedPlatforms;
